const navData = [
  { title: "Inicio", to: "/" },
  { title: "Tienda", to: "/collections/coffee-blends" },
  { title: "Historia", to: "/about-us" },
];
export default navData;
